import { createI18n } from 'vue-i18n';
import cs from './cs.json';
import sk from './sk.json';

const messages = {
    cs,
    sk
};

const i18n = createI18n({
    legacy: false, // Musí být false, pokud používáš Composition API
    locale: localStorage.getItem('lang') || 'cs', // Výchozí jazyk
    fallbackLocale: 'cs', // Záložní jazyk
    messages,
});

export default i18n;
